import { postApi } from "./helpers/apiMethods";

export type V2FeedbackCategory =
  | "missing_feature"
  | "performance"
  | "visual_bug"
  | "preference"
  | "other";

export interface V2UiPreferenceSwitchbackFeedbackRequest {
  customerId: string;
  category: V2FeedbackCategory;
  comment?: string;
  fromUrl: string;
}

export async function postV2UiPreferenceSwitchbackFeedback(
  request: V2UiPreferenceSwitchbackFeedbackRequest
): Promise<void> {
  const { customerId, category, comment, fromUrl } = request;
  const body: { category: V2FeedbackCategory; fromUrl: string; comment?: string } = {
    category,
    fromUrl,
  };
  if (comment !== undefined) {
    body.comment = comment;
  }
  await postApi(
    `/v1/customers/${customerId}/feedback/v2-ui-preference-switchback`,
    body
  );
}
